const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/content/add.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { setPageFullScreen } from '@/Components/templates/Page';
import { requireUserPostCaps } from '@/Router';
import { createFileRoute } from '@tanstack/react-router';
import './AddEditContent.less';
export const Route = createFileRoute('/dash/content/add')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  beforeLoad: () => {
    requireUserPostCaps('catalog', 'create_post', {
      to: '/dash/catalog'
    });
  },
  onEnter: () => {
    setPageFullScreen('on');
  },
  onLeave: () => {
    setPageFullScreen('off');
  }
});